module.exports = __webpack_public_path__ + "static/trekking-9b36c33dd83472e129a6c4e517a5daa7.jpg";